import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Alert,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
} from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';

interface AddTemplateDialogProps {
  open: boolean;
  onClose: () => void;
  selectedDocumentId: string;
  setSelectedDocumentId: (id: string) => void;
  selectedTemplateType: string;
  setSelectedTemplateType: (type: string) => void;
  saveTemplate: () => void;
  saving: boolean;
  permissions: any[];
  documents: any[];
}

const AddTemplateDialog: React.FC<AddTemplateDialogProps> = ({
  open,
  onClose,
  selectedDocumentId,
  setSelectedDocumentId,
  selectedTemplateType,
  setSelectedTemplateType,
  saveTemplate,
  saving,
  permissions,
  documents,
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Add Document Template</DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 1 }}>
          <FormControl fullWidth>
            <InputLabel>Template Type</InputLabel>
            <Select
              value={selectedTemplateType}
              onChange={(e) => {
                setSelectedTemplateType(e.target.value);
              }}
              label="Template Type"
            >
              {permissions
                .filter(permission => permission.isActive)
                .map((permission) => (
                  <MenuItem key={permission.permissionId} value={permission.permissionName}>
                    {permission.displayName}
                  </MenuItem>
                ))}
            </Select>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
              Select a permission to associate with this template
            </Typography>
          </FormControl>
          
          <FormControl fullWidth>
            <InputLabel>Select Document</InputLabel>
            <Select
              value={selectedDocumentId}
              onChange={(e) => setSelectedDocumentId(e.target.value)}
              label="Select Document"
            >
              {documents.map((doc) => (
                <MenuItem key={doc.fileID} value={doc.fileID}>
                  {doc.fileName} (ID: {doc.fileID})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          {documents.length === 0 && (
            <Alert severity="warning">
              No documents available. Please upload documents in the Document Management tab first.
            </Alert>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          startIcon={<SaveIcon />}
          onClick={saveTemplate}
          disabled={saving || !selectedDocumentId || !selectedTemplateType}
        >
          {saving ? 'Saving...' : 'Save Template'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddTemplateDialog;
